import React from "react";
import { DragableLayout } from "../components";

export const DesignPage = ({ storeKey, userType }) => {
  return (
    <>
      <DragableLayout storeKey={storeKey} userType={userType}/>
    </>
  );
};
